export default (hit) => {
  const labelsType = {
    'activity-report': 'Rapport d\'activité',
    study: 'Étude',
    'btob-news': 'BtoB News',
    'practical-guide': 'Note adhérent',
    'barometer-activity': 'Baromètre d\'activité',
    'thematic-brochure': 'Plaquette thématique',
    article: 'Actualité',
    agenda: 'Agenda',
    event: 'Événement',
    page: 'Page',
  }

  const hasBgColor = ['event', 'agenda', 'news', 'practical-guide', 'thematic-brochure'].includes(hit.type)
  const isEvent = hit.type === 'agenda' || hit.type === 'event'

  let date = null
  let date2 = null

  let bgClass = 'bg-violet'

  if (hit.type === 'thematic-brochure') {
    bgClass = 'bg-orange'
  }

  if (hit.groupType === 'publication' || hit.group === 'article') {
    date = new Date(hit.publicationDate.date)
    date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
  } else if (hit.type === 'agenda' || hit.type === 'event') {
    date = new Date(hit.startEventDate.date)
    date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`

    if (hit.endEventDate) {
      date2 = new Date(hit.endEventDate.date)
      date2 = `${date2.getDate().toString().padStart(2, '0')}.${(date2.getMonth() + 1).toString().padStart(2, '0')}.${date2.getFullYear()}`
    }
  }

  const hasDate = date !== null

  return `
    <a href="/${hit.path}" class="search-panel-hit ${hit.type === 'agenda' || hit.type === 'event' ? 'search-panel-hit--event' : ''} ${hasBgColor ? `search-panel-hit--bg ${bgClass}` : ''}">
      <div>
        <p>${hit.title}</p>

        ${isEvent || hasDate
          ? `<div class="search-panel-hit__infos">
              <p class="flex items-center">
                <svg width="12" height="12" class="mr-2 ${isEvent ? 'icon--orange' : hit.type === 'practical-guide' ? 'icon--white' : 'icon--violet'}">
                  <use href="#icon-hour" xlink:href="#icon-hour"></use>
                </svg>
                <span>${isEvent ? date2 ? 'Du' : 'Le' : 'Publié le'} <span class="font-bold ${hasBgColor ? '' : 'text-violet'}">${date}</span>${date2 ? ` au <span class="font-bold">${date2}</span>` : ''}</span>
              </p>
              ${isEvent && hit.place !== null && hit.place !== ''
                ? `<div class="flex items-center">
                    <svg width="9" height="12" class="mr-2 icon--orange flex-shrink-0 icon-pin">
                      <use href="#icon-pin" xlink:href="#icon-pin"></use>
                    </svg>
                    <span>À <span class="font-bold">${hit.place}</span></span>
                  </div>`
                : ''
              }
            </div>`
          : ''
        }
      </div>
      <div class="flex flex-shrink-0 pt-3 md:pt-0">
        ${hit.isMemberOnly
          ? `<span class="tag tag--adherent mr-2">
              <svg width="10" height="13" class="mr-1 icon--violet">
                <use href="#icon-lock" xlink:href="#icon-lock"></use>
              </svg>
              Adhérent
            </span>`
          : ''
        }
        <span class="tag ${hit.type === 'page' ? 'tag--page' : ''}">${labelsType[hit.type]}</span>
      </div>
    </a>
  `
}
